<template>
  <v-container fluid>
    <!-- <div id="app">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap style="padding-left: 10px">
          <v-flex xs2 pa-2>
            <v-menu
              ref="menu"
              :close-on-content-click="false"
              v-model="menu"
              :nudge-right="0"
              :return-value.sync="date"
              transition="scale-transition"
              lazy
              offset-y
              full-width
              min-width="290px"
            >

              <v-text-field
                slot="activator"
                v-model="date"
                label="Datum od"
                readonly
              ></v-text-field>
              <v-date-picker
                v-model="date"
                no-title
                scrollable
                :max="maxDate"
                v-on:change="changeDate"
              >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs2 pa-2>
            <v-menu
              ref="menuTo"
              :close-on-content-click="false"
              v-model="menuTo"
              :nudge-right="0"
              :return-value.sync="dateTo"
              transition="scale-transition"
              lazy
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="dateTo"
                label="Datum do"
                readonly
              ></v-text-field>

              <v-date-picker
                v-model="dateTo"
                no-title
                scrollable
                :max="maxDate_input"
                :min="minDate"
                v-on:change="changeInputDate"
              >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="menuTo = false"
                  >Cancel</v-btn
                >
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs6 pa-3>
            <v-btn :disabled="!valid" @click="submit" class="AppButtonFilled"
              >Prikaži</v-btn
            >
            <v-btn @click="clear" class="AppButtonOutlined">Poništi</v-btn>
          </v-flex>
        </v-layout>

      </v-form>
      <TokenComponent ref="frmtoken" />
    </div> -->

    <v-layout>
        <v-flex xs12>
          <!--  -->
          <MyComponentChart
              :item="graphic_data"
              :ucitan_grafik="ucitaj_grafik"
              :naslov="naslov_grafik"
            ></MyComponentChart>
        </v-flex>
      </v-layout>
  </v-container>
</template>

<script>
// export default {
//   name: "grafik",

//   data () {
// 		return {
// 			chartData: [
//   {name: 'Temperatura', data: {'2017-01-01': 3, '2017-01-02': 4, '2017-01-03': 12, '2017-01-05': 18, '2017-01-06': 24}},
//   {name: 'Secer', data: {'2017-01-01': 5, '2017-01-02': 3, '2017-01-04': 18, '2017-01-05': 18, '2017-01-06': 15}}
// ],
//       spanGaps: true
// 		}
// 	}
// }

import TokenComponent from "../components/Token";

import { serverBus } from "../main";
import { readJSON } from "../helpers/Functions";


import MyComponentChart from "../components/AmrChratGrafic.vue";

export default {
  name: "grafik",
  components: {
    TokenComponent,
    MyComponentChart
  },
  computed: {
    maxDate_input() {
      var tomorrow = new Date();
      tomorrow.setDate(new Date().getDate() + 1);

      // const dd = today.getUTCDate();
      return this.formatDate(tomorrow);
    },
    maxDate: {
      // getter
      get: function () {
        return this.max_date;
      },
      // setter
      set: function (newValue) {
        alert(newValue);
        this.max_date = newValue;
      },
    },
    minDate: {
      // getter
      get: function () {
        return this.min_date;
      },
      // setter
      set: function (newValue) {
        this.min_date = newValue;
      },
    },
  },
  data() {
    return {
      valid: true,
      date: undefined, //For datepicker
      menu: "",
      dateTo: undefined, //For datepicker
      menuTo: "",
      max_date: "",
      min_date: "",
      graphic_data: [],
      ucitaj_grafik: true,
      naslov_grafik: undefined
    };
  },
  methods: {
    
    changeInputDate(a) {
      this.max_date = a;

      this.$refs.menuTo.save(a);
    },
    changeDate(a) {
      this.min_date = a;

      this.$refs.menu.save(a);
    },
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (typeof this.date === "undefined")
          alert("Niste uneli početak perioda.");
        else if (typeof this.dateTo === "undefined")
          alert("Niste uneli kraj perioda.");
        else this.getAllSifarnik();
      }
    },
    clear() {
      // this.$refs.form.reset();
    },
    getAllSifarnik() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/measurement/sugar_and_temperature/" +
            this.tank_phase_vineId +
            "/graphs?from=" +
            this.date +
            "T00:00:00&to=" +
            this.dateTo +
            "T00:00:00",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          let _this = this;
          let podaci = response.data;
          let objPom;
          let i = 0;

          podaci.dates.forEach(function (element) {
            console.log(podaci.descriptions[i]);

            objPom = {
              date: element,
              temperatura: podaci.temperature[i],
              secer: podaci.sugar[i],
              opis: podaci.descriptions[i]
            };

            i = i + 1;

            _this.graphic_data.push(objPom);
          });

          // this.ucitajGrafik();
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/measurement/sugar_and_temperature/" +
                        this.tank_phase_vineId +
                        "/graphs?from=" +
                        this.date +
                        "T00:00:00&to=" +
                        this.dateTo +
                        "T00:00:00",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      let _this = this;
          let podaci = response.data;
          let objPom;
          let i = 0;

          podaci.dates.forEach(function (element) {
            objPom = {
              date: element,
              temperatura: podaci.temperature[i],
              secer: podaci.sugar[i],
              opis: podaci.descriptions[i]
            };

            i = i + 1;

            _this.graphic_data.push(objPom);
          });

          // this.ucitajGrafik();
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllSifarnikInit() {
      // alert(this.tank_phase_vineId);

      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/measurement/sugar_and_temperature/" +
            this.tank_phase_vineId +
            "/graphs",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          

          let _this = this;
          let podaci = response.data;
          let objPom;
          let i = 0;

          podaci.dates.forEach(function (element) {
            objPom = {
              date: Date.parse(element),
              temperatura: podaci.temperature[i],
              secer: podaci.sugar[i],
              opis: podaci.descriptions[i]
            };

            i = i + 1;

            _this.graphic_data.push(objPom);
          });

          // this.ucitajGrafik();
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/measurement/sugar_and_temperature/" +
                        this.tank_phase_vineId +
                        "/graphs",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      let _this = this;
          let podaci = response.data;
          let objPom;
          let i = 0;

          podaci.dates.forEach(function (element) {
            objPom = {
              date: element,
              temperatura: podaci.temperature[i],
              secer: podaci.sugar[i],
              opis: podaci.descriptions[i]
            };

            i = i + 1;

            _this.graphic_data.push(objPom);
          });

          // this.ucitajGrafik();
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
  },
  mounted() {
    this.clear();

    serverBus.$on("refresh_grafik", (id_tank_phase_wine) => {
      // alert(id_tank_phase_wine);

      this.tank_phase_vineId = id_tank_phase_wine;

      this.getAllSifarnikInit();
    });
  },
};
</script>

<style scoped lang='scss'>
  // div.am5-html-container{
  //   width: 100% !important;
  //   height: 100% !important;
    
  // }

  // canvas{
  //   width: 100% !important;
  //   height: 100% !important;
  // }

  .parent {
  display: flex;
  flex-wrap: wrap;
  gap: 1;
}

.child {
  flex: 0 0 100%;
}

.chart {
  /*width: 100%;*/
  height: 600px;
  
  /* Uncomment the line below and the charts grow by itself */
  /*border: 3px solid black;*/
}
</style>